<template>
  <div v-loading="loading" class="page finance-order-detail">
    <div class="block state">
      <el-steps :active="activeStep">
        <el-step v-for="step in steps" :key="step.state" :title="step.name" :description="step.time | dateTimeFmt"></el-step>
      </el-steps>
    </div>
    <div class="block summary">
      <div class="title">订单信息</div>
      <div class="info-table">
        <table>
          <tr>
            <td>订单编号</td>
            <td>{{ order.orderSn }}</td>
            <td>下单时间</td>
            <td>{{ order.createTime | dateTimeFmt }}</td>
          </tr>
          <tr>
            <td>卖家</td>
            <td>{{ order.subSellerName }}</td>
            <td>买家信息</td>
            <td>{{ order.buyerName }}/{{ order.buyerPassportName }}/{{ phoneShow(order.phone) }}</td>
          </tr>
          <tr>
            <td>收货信息</td>
            <td colspan="3">{{ order.nameAddressee }}/{{ phoneShow(order.phoneAddressee) }}/{{ order.addressAddressee }}</td>
          </tr>
          <tr v-if="order.timePay">
            <td>支付时间</td>
            <td>{{ order.timePay | dateTimeFmt }}</td>
            <td>支付方式</td>
            <td>{{ payTypes[order.payType] }}</td>
          </tr>
          <tr>
            <td>配送要求</td>
            <td>{{ order.express || '物流发货' }}</td>
            <td>发货要求</td>
            <td>{{ order.isUnifiedDelivery ? '到齐发货' : '先到先发' }} {{ order.isNeedList ? '需要清单' : '无需清单' }}</td>
          </tr>
          <tr>
            <td>买家留言</td>
            <td colspan="3">{{ order.memo }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="deliveries && deliveries.length" class="block deliveries">
      <div class="title">发货记录</div>
      <div class="packages">
        <div class="package" v-for="del in deliveries" :key="del.deliveryId">
          <div class="index">
            包裹{{ del.index }}
            <div v-if="!del.deliveryImages" class="state">出库中</div>
          </div>
          <div class="cont">
            <div>
              <label>出库时间</label>{{ del.createTime | dateTimeFmt }}
            </div>
            <div>
              <label>发货门店</label>{{ del.shopName }}
            </div>
            <div>
              <label>操作人</label>{{ del.operatorName }}
            </div>
            <div>
              <label>配送方式</label>{{ ['', '物流发货', '司机送货', '物流发货', '客户自提'][del.deliveryType] }}
            </div>
            <div>
              <label>配送信息</label>
              <template v-if="del.deliveryType===1 || del.deliveryType === 3">
                {{ del.logisticsCompany }}<span v-if="del.logisticsSn"> / {{ del.logisticsSn }}</span>
              </template>
              <template v-else-if="del.deliveryType===2">
                {{ del.driverInfo }}
              </template>
              <template v-else-if="del.deliveryType===4">
                {{ [del.pickupInfo,del.pickupTime&& '自提时间：' + dateFmt(del.pickupTime)].filter(e=>e).join('/') }}
              </template>
              <template v-else>
                {{ del.expressInfo }}
              </template>
            </div>
            <div>
              <label>配件信息</label>
              <el-popover trigger="hover">
                <div class="del-package-table-wraper">
                  <table class="tb-header">
                    <thead>
                      <tr>
                        <td>编号</td>
                        <td>名称</td>
                        <td>数量</td>
                      </tr>
                    </thead>
                  </table>
                  <table class="tb-body">
                    <tbody>
                      <tr v-for="item in del.items" :key="item.orderItemId">
                        <td>{{ item.partCode }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.quantity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <el-button slot="reference" style="padding: 0;" type="text">
                  {{ del.items.length }}种，{{ del.items.reduce((p, c) => p + c.quantity, 0) }}件
                </el-button>
              </el-popover>
            </div>
            <div>
              <label>发货图片</label>
              <delivery-attachment-shower v-if="del.images && del.images.length" :urls="del.images" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="order.invoices && order.invoices.length" class="block invoices">
      <div class="title">关联开票记录</div>
      <div class="cont">
        <table class="invoice-table">
          <tr>
            <th>申请时间</th>
            <th>申请单号</th>
            <th>发票抬头</th>
            <th>注册信息</th>
            <th>开户行</th>
            <th>开票金额</th>
            <th>状态</th>
          </tr>
          <tr v-for="invoice in order.invoices" :key="invoice.id">
            <td>{{ invoice.createTime | dateTimeFmt }}</td>
            <td>{{ invoice.sn }}</td>
            <td><div>{{ invoice.title }}</div><div>{{ invoice.taxpayerId }}</div></td>
            <td><div>{{ invoice.registeredAddress }}</div><div>{{ invoice.registeredPhone }}</div></td>
            <td><div>{{ invoice.bankName }}</div><div>{{ invoice.bankAccount }}</div></td>
            <td>
              {{ invoice.orderAmount | currencyFmt }}<el-button type="text" style="margin-left: 6px; padding: 0" @click="showInvoicesDetail(invoice.id)">明细</el-button>
            </td>
            <td>
              <div>{{ invoice.state === 2 ? '已开票' : '开票中' }}</div>
              <div v-if="invoice.state === 2">
                <a v-for="(url, idx) in (invoice.image || '').split(',')" target="_blank" :key="idx" :href="url">发票{{ idx + 1 }}</a>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="block part-header">
      <div class="header">
        <div class="title">配件列表</div>
        <div class="actions">
          <el-input size="mini" placeholder="配件编号搜索" v-model="keywords" clearable></el-input>
        </div>
      </div>
      <table class="part-table-header">
        <thead>
          <tr>
            <th>品牌</th>
            <th>编号</th>
            <th>名称</th>
            <th>发货门店</th>
            <th>4S进价</th>
            <th>单价</th>
            <th>数量</th>
            <th>小计</th>
            <th>已发货</th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="block parts">
      <table class="part-table-body">
        <tbody>
          <tr v-for="item in order.items.filter(t => !keywords || ~t.sn.indexOf(keywords) || ~(t.supersession || '').indexOf(keywords))" :key="item.orderItemId">
            <td>{{ orderBrands[item.brandCode] || '其他' }}</td>
            <td>
              <span v-if="item.supersession && item.supersession !== item.sn">
                {{ item.supersession }}
                <el-tooltip v-if="item.systemDiffPrice" :content="`替换件差价:${item.systemDiffPrice}`">
                  <span class="superssion-badge">替</span>
                </el-tooltip>
                <span v-else class="superssion-badge">替</span>
                /
              </span>
              {{ item.sn }}
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.warehouse }}</td>
            <td>{{ item.cost4S | currencyFmt }}</td>
            <td>{{ item.price | currencyFmt }}</td>
            <td>{{ item.quantity }}<el-button style="padding: 0" type="text" v-if="order.invoiceOrderId === 0 && item.quantityReturn > 0" @click="showReturn(item.orderItemId)">(售后:{{ item.quantityReturn }})</el-button></td>
            <td>{{ item.price * item.quantity | currencyFmt }}</td>
            <td>
              <el-button style="padding: 0" type="text" @click="showDelivery(item.orderItemId)">{{ item.quantityDelivered }}</el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="total-info">
        <div v-if="diffPrice"><label>差价金额：</label>{{ diffPrice | currencyFmt }}</div>
        <div v-if="diffPrice"><label>差价金额：</label>{{ diffPrice | currencyFmt }}</div>
        <div><label>合计金额：</label>{{ order.amount }}</div>
        <div v-if="beanExchange"><label>积分抵扣：</label>{{ beanExchange | currencyFmt }}</div>
        <div v-if="reductionAmount"><label>满减优惠：</label>{{ reductionAmount | currencyFmt }}</div>
        <div v-if="couponAmount"><label>优惠券：</label>{{ couponAmount | currencyFmt }}</div>
        <div v-if="order.amount > order.amountPay"><label>合计优惠：</label>{{ order.amount - order.amountPay }}</div>
        <div><label>支付金额：</label>{{ order.amountPay }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { DetailOrder } from './services.js'
import DeliveryAttachmentShower from '../order/partials/DeliveryAttachmentShower.vue'
import _ from 'lodash'
export default {
  name: 'FinanceOrderDetail',
  components: { DeliveryAttachmentShower },
  data () {
    return {
      loading: false,
      keywords: '',
      order: {
        id: undefined,
        orderSn: '',
        isNeedList: false,
        isUnifiedDelivery: false,
        phone: '',
        payType: 0,
        state: 0,
        createTime: undefined,
        timePay: undefined,
        timeConfirm: undefined,
        timeCancel: undefined,
        timeDelivery: undefined,
        timeReceived: undefined,
        timeFinish: undefined,
        buyerName: '',
        phoneAddreessee: '',
        nameAddressee: '',
        addressAddressee: '',
        amountPay: '',
        amount: '',
        invoiceOrderId: undefined,
        items: []
      }
    }
  },
  computed: {
    diffPrice () {
      return this.order.items.filter(t => t.sn === '11111111').reduce((p, c) => p + c.price, 0)
    },
    beanExchange () {
      return this.order.items.reduce((p, c) => p + c.beanExchange * c.quantity / c.orderQty, 0) / 100
    },
    reductionAmount () {
      return this.order.items.reduce((p, c) => p + c.reductionAmount * c.quantity / c.orderQty, 0)
    },
    couponAmount () {
      return this.order.items.reduce((p, c) => p + c.couponAmount * c.quantity / c.orderQty, 0)
    },
    id () {
      return this.$route.params.id
    },
    activeStep () {
      return this.steps.filter(t => t.time).length
    },
    steps () {
      const { createTime, timeConfirm, timePay, timeDelivery, timeReceived, timeFinish, timeCancel } = this.order
      if (this.order.state === -1) {
        return [
          {
            state: 1,
            name: '提交订单',
            time: createTime
          },
          {
            state: 2,
            name: '已确认',
            time: timeConfirm
          },
          {
            state: -1,
            name: '已取消',
            time: timeCancel
          }
        ].filter(t => t.time)
      }
      if (this.order.state === -2) {
        return [
          {
            state: 1,
            name: '提交订单',
            time: createTime
          },
          {
            state: 2,
            name: '已确认',
            time: timeConfirm
          },
          {
            state: 3,
            name: '已付款',
            time: timePay
          },
          {
            state: -2,
            name: '已退款',
            time: timeFinish
          }
        ].filter(t => t.time)
      }
      return [
        {
          state: 1,
          name: '提交订单',
          time: createTime
        },
        {
          state: 2,
          name: '已确认',
          time: timeConfirm
        },
        {
          state: 3,
          name: '已付款',
          time: timePay
        },
        {
          state: 4,
          name: '已发货',
          time: timeDelivery
        },
        {
          state: 5,
          name: '已收货',
          time: timeReceived
        },
        {
          state: 6,
          name: '已完成',
          time: timeFinish
        }
      ]
    },
    payTypes () {
      return this.$store.state.payTypes
    },
    orderBrands () {
      const brandDict = {};
      (this.$store.state.orderBrands || []).forEach(item => {
        brandDict[item.code] = item.name
      })
      return brandDict
    },
    deliveries () {
      const packages = []
      const grps = _.groupBy(this.order.packages, i => i.deliveryId)
      let index = 0
      for (const grp in grps) {
        index++
        const { createTime, deliveryId, deliveryType,
          deliveryImages, logisticsCompany, expressInfo,
          pickupInfo, pickupTime, operatorName, shopName } = grps[grp][0]
        const items = grps[grp].map(t => {
          const { orderItemId, quantity } = t
          const orderItem = this.order.items.find(s => s.orderItemId === orderItemId)
          const { sn, supersession, name } = orderItem
          return {
            orderItemId,
            quantity,
            partCode: supersession || sn,
            name
          }
        })
        packages.push({
          index,
          createTime,
          deliveryId,
          deliveryType,
          deliveryImages,
          images: deliveryImages.split(','),
          logisticsCompany,
          expressInfo,
          pickupInfo,
          pickupTime,
          operatorName,
          shopName,
          items
        })
      }
      return packages
    }
  },
  async beforeMount () {
    if (!this.orderBrands.length) {
      await this.$store.dispatch('loadOrderBrands')
    }
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      DetailOrder(this.id).then(resp => {
        if (resp.timePay && resp.timeConfirm === null) {
          resp.timeConfirm = resp.createTime
        }
        this.order = resp
      }).finally(() => {
        this.loading = false
      })
    },
    showReturn (orderItemId) {
      this.modal('OrderReturnDetailModal', orderItemId).promise.catch(() => {})
    },
    showDelivery (orderItemId) {
      this.modal('RelPackageModal', orderItemId, this.deliveries).promise.catch(() => {})
    },
    showInvoicesDetail (invoiceId) {
      const { invoiceOrderId, orderSn } = this.order
      this.modal('InvoiceDetailModal', { invoiceId, invoiceOrderId, orderSn })
    }
  }
}
</script>
